import { render, staticRenderFns } from "./xIndex.vue?vue&type=template&id=1d985a40"
import script from "./xIndex.vue?vue&type=script&lang=js"
export * from "./xIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports